document.addEventListener("DOMContentLoaded", () => {
  const textarea = document.querySelector(".product-form__input.invite_text textarea");
  const charCountLabel = document.querySelector(".char-count");

  if (textarea && charCountLabel) {
    const maxLimit = parseInt(textarea.getAttribute("data-limit"), 10);

    textarea.addEventListener("input", () => {
      // Split text into words and filter out empty strings caused by multiple spaces
      let words = textarea.value.split(/\s+/).filter(word => word.length > 0);

      // Trim the value if it exceeds the word limit
      if (words.length > maxLimit) {
        words = words.slice(0, maxLimit);
        textarea.value = words.join(" ");
      }

      // Update the count label
      charCountLabel.textContent = `${words.length}/${maxLimit}`;
    });
  }
});
